import ModalDarkProvider from "@/components/context/ModalDarkProvider"
import { WebsiteLoader } from "@/components/layout/WebsiteLoader"
import { useGoogleAnalytics } from "@/hooks/useGoogleAnalytics"
import { usePageMeta } from "@/hooks/usePageMeta"
import { Layout } from "antd"
import { FC, Suspense } from "react"
import { Outlet } from "react-router"
import "../../styles/tooltip.less"
import "./index.less"

const AuthLayout: FC = () => {
  useGoogleAnalytics()
  usePageMeta()

  return (
    <ModalDarkProvider>
      <Layout>
        <Suspense fallback={<WebsiteLoader />}>
          <Outlet />
        </Suspense>
      </Layout>
    </ModalDarkProvider>
  )
}

export { AuthLayout }
